export const uniqueElementsById = (entities) => {
    const map = new Map();
    return entities.filter((entity) => {
        if (entity && !map.has(entity.id)) {
            map.set(entity.id, true);
            return true;
        }
        return false;
    });
};
//# sourceMappingURL=uniqueElementsById.js.map